import React, { useState, useEffect } from "react";
import useAxios from "../../helpers/useAxios";
import { getCurrentDate } from "../../helpers/utils.js";

const CaracterizacaoFundo = (props) => {
  const [fundData, setFundData] = useState({});

  const { data, error, loaded } = useAxios("POST", "/Funds/funds-detail", {
    nif: props.nif,
    id: parseInt(props.id),
  });

  useEffect(() => {
    if (loaded && error.length === 0)
      setFundData(data)
  }, [data]);

  return (
    <div className="col-md-12 bg-white rounded-4 p-3">
      <h4 className="mt-4 mb-5 me-1 ms-1">Caracterização</h4>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
          Fundo
        </div>
        <div className="col-8 text-end">
          {fundData.fundName}
        </div>
      </div>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
          Tipo de fundo
        </div>
        <div className="col-8 text-end">
        {fundData.type}
        </div>
      </div>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
        Volume sob gestão
        </div>
        <div className="col-8 text-end">
        {fundData.volume} EUR
        </div>
      </div>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
        Cotação a {getCurrentDate()}
        </div>
        <div className="col-8 text-end">
        {fundData.cotacao} EUR
        </div>
      </div>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
          Nível de risco <sup>1</sup>
        </div>
        <div className="col-8 text-end">
        {fundData.escalaoRisco}
        </div>
      </div>
      <div className="row pb-4 mb-4 me-1 ms-1 border-bottom border-primary">
        <div className="col-4 col-info-ttl" style={{color:'#3F5B78'}}>
        Rendibilidade último ano
        </div>
        <div className="col-8 text-end">
        {fundData.rentabilidade} %
        </div>
      </div>
      <p className="ms-1" style={{fontSize:'11px', textAlign:'justify', color:'#666666'}}>
        <sup>1</sup> O nível de risco e remuneração do Fundo é apurado com base no desvio padrão das UP nos últimos 5 anos sendo efetuada uma correspondência em função dos intervalos de volatilidade: classe 1: 0,0% a 0,5%; classe 2: 0,5% a 2,0%; classe 3: 2,0% a 5,0%; classe 4: 5,0% a 10%; classe 5: 10,0% a 15,0%; classe 6: 15,0% a 25%; classe 7: ≥ 25%.<br /><br />
        As rendibilidades divulgadas representam dados passados, não constituindo garantia de rendibilidade futura. A rendibilidade refere-se ao período de um ano e só seria obtida se o investimento fosse efetuado durante a totalidade desse período. Os valores apresentados são calculados com base nos valores diários das Unidades de Participação (UP) do Fundo.<br /> 
        O valor da UP dos Fundos de Pensões evolui, em cada momento, em função do valor dos ativos integrantes da carteira do Fundo, pelo que pode aumentar ou diminuir, sendo o respetivo valor divulgado diariamente, nos dias úteis.<br />
        Os valores apresentados foram calculados com base nas UP diárias do Fundo, que refletem o potencial de valorização dos ativos subjacentes e o valor atual dos rendimentos futuros.<br />
        O valor da UP é líquido de comissões e impostos na esfera do Fundo, estando o investidor sujeito à aplicação das comissões contratualizadas, nomeadamente comissão de reembolso ou de subscrição caso tal se aplique, bem como à fiscalidade inerente a este produto a título de imposto sobre os rendimentos das pessoas singulares.<br />
        Os Fundos de Pensões encontram-se isentos de imposto sobre o rendimento, exceto na situação prevista no n.º11 do art.º 88.º do Código do IRC. Por regra, os participantes são tributados no momento do reembolso, por retenção na fonte.<br />
        Os Documentos Constitutivos dos Fundos de Pensões encontram-se disponíveis em na área: Extrato Individual &gt; Informação sobre o Fundo.<br />
        Caso cesse o vínculo laboral, o valor associado aos direitos adquiridos poderá diferir do apresentado, de acordo com as regras do plano de Pensões.<br />
        Os valores apresentados são referentes à situação financeira específica do Participante.<br />
        A CGD PENSÕES, Sociedade Gestora de Fundos de Pensões, S.A., não é responsável pela realização das contribuições a cargo do Associado.
      </p>
    </div>
  );
};

export default CaracterizacaoFundo;
